import { ActivateItemData } from '../types/items';
import HttpHelpers from './helpers';

const ItemsApiEndpoints = {
  getItemDetails: (qrCode: string) => HttpHelpers.unAuthenticatedAxios
    .get(`/api/v1/items/item_details?qr_code=${encodeURIComponent(qrCode)}`)
    .then((response) => response.data),
  activateItem: (data: ActivateItemData) => HttpHelpers.authenticatedAxios
    .post('/api/v2/customer/items/activate', data)
    .then((response) => response.data),
};

export default ItemsApiEndpoints;
